export default "__VITE_ASSET__CcyTnP82__"